module.exports = __webpack_public_path__ + "img/shucai1.521e6aad.png";